// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import { Stack } from '@mantine/core';
import type { JSX } from 'react';
import { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import type { PageTabsItem } from '../../components/layout/PageTabs';
import { PageTabs } from '../../components/layout/PageTabs';
import { GrantListTab } from './GrantListTab';
import { SweListTab } from './SweListTab';

const SWE_ACCESS_TABS: PageTabsItem[] = [
  { id: 'by-engineer', label: 'By Engineer' },
  { id: 'all-grants', label: 'All Grants' },
];

export function SweAccessTab(): JSX.Element {
  const [tab, setTab] = useState('by-engineer');

  return (
    <Stack gap="md">
      <PageHeader title="SWE Access" actions={<PageTabs tabs={SWE_ACCESS_TABS} value={tab} onChange={setTab} />} />

      {tab === 'by-engineer' && <SweListTab />}
      {tab === 'all-grants' && <GrantListTab />}
    </Stack>
  );
}
